var _tspan, _animate, _animate2, _animate3, _animate4, _animate5, _animate6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhoMobD(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "da06b718-fe03-4785-8137-d274c50abe1a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.69 50.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MOBILEdark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 22.34,
    cy: 43.98,
    r: 19.25,
    transform: "matrix(0.01, -1, 1, 0.01, -23.91, 51.26)",
    style: {
      fill: "none",
      stroke: "#f9f9f9",
      strokeMiterlimit: 10,
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.48,
    cy: 14.47,
    r: 5.71,
    style: {
      fill: "#036574"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.28,
    cy: 29.01,
    r: 17.23,
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.41,50a.14.14,0,0,1-.1.15.13.13,0,0,1-.15-.09.13.13,0,0,1,.09-.16h.08a.12.12,0,0,1,.08.09",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#05949c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.74,51.21a.13.13,0,0,1-.09.16.12.12,0,0,1-.15-.09.12.12,0,0,1,.08-.15.13.13,0,0,1,.16.08",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#05949c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.15,52.4h0a.12.12,0,0,1-.07.16.13.13,0,0,1-.17-.07A.12.12,0,0,1,3,52.33a.08.08,0,0,1,.08,0,.1.1,0,0,1,.08.07",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#05949c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.64,53.56a.13.13,0,0,1-.07.17.12.12,0,0,1-.16-.07.12.12,0,0,1,.06-.16.1.1,0,0,1,.09,0,.14.14,0,0,1,.08.07",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#05949c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2,54.69a.13.13,0,0,1,0,.17.14.14,0,0,1-.18,0A.13.13,0,0,1,4,54.63a.12.12,0,0,1,.1,0,.13.13,0,0,1,.07.06",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#05949c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1,63.81A.14.14,0,0,1,28,64a.12.12,0,0,1-.16-.08.12.12,0,0,1,.07-.16.14.14,0,0,1,.09,0,.18.18,0,0,1,.08.07",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#05949c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.83,55.78h0a.13.13,0,0,1-.22.14.14.14,0,0,1,0-.18.14.14,0,0,1,.11,0,.17.17,0,0,1,.06.06",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#05949c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9,64.22a.13.13,0,0,1-.25.07.13.13,0,0,1,.09-.16h.08a.18.18,0,0,1,.08.09",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#05949c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.53,56.82h0a.13.13,0,0,1,0,.18.13.13,0,0,1-.17,0h0a.14.14,0,0,1,0-.18.17.17,0,0,1,.12,0,.15.15,0,0,1,.06,0",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#05949c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.67,64.54a.12.12,0,0,1-.1.15.13.13,0,0,1-.15-.1.14.14,0,0,1,.1-.15h.07a.11.11,0,0,1,.08.09",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#05949c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3,57.82h0a.13.13,0,1,1-.18,0,.13.13,0,0,1,.12,0l.06,0",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#05949c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.43,64.78a.13.13,0,0,1-.11.15.13.13,0,0,1-.14-.11.12.12,0,0,1,.1-.14.16.16,0,0,1,.07,0,.16.16,0,0,1,.08.1",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#05949c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.13,58.77h0a.12.12,0,0,1,0,.17.13.13,0,0,1-.18,0h0a.14.14,0,0,1,0-.18.16.16,0,0,1,.13,0l0,0",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#05949c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.17,64.94a.12.12,0,0,1-.11.14.12.12,0,0,1-.14-.11.13.13,0,0,1,.12-.14h.05a.1.1,0,0,1,.08.1",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#05949c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,59.66a.14.14,0,0,1,0,.18.13.13,0,0,1-.19-.18.12.12,0,0,1,.14,0s0,0,0,0",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#05949c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.91,65a.14.14,0,0,1-.12.14.13.13,0,0,1-.13-.13.12.12,0,0,1,.12-.13h0a.12.12,0,0,1,.08.11",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#05949c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,60.49a.13.13,0,0,1-.17.19.12.12,0,0,1,0-.17.11.11,0,0,1,.14,0l0,0",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#05949c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.65,65a.13.13,0,0,1-.14.12.13.13,0,1,1,0-.25h0a.14.14,0,0,1,.09.12",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#05949c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,61.26a.12.12,0,0,1,0,.17.12.12,0,0,1-.17,0,.13.13,0,0,1,0-.18.12.12,0,0,1,.14,0l0,0",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#05949c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.38,64.94a.13.13,0,1,1-.11-.14h0a.12.12,0,0,1,.08.13",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#05949c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,62a.13.13,0,0,1,0,.18.12.12,0,0,1-.17,0,.13.13,0,0,1-.05-.17.13.13,0,0,1,.16-.06s0,0,0,0",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#05949c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.13,64.77a.14.14,0,0,1-.15.11.12.12,0,0,1-.1-.15.11.11,0,0,1,.14-.1h0a.13.13,0,0,1,.09.14",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#05949c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1,62.58h0a.14.14,0,0,1,.05.18.13.13,0,0,1-.17.05.12.12,0,0,1-.05-.17.12.12,0,0,1,.15-.06h0",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#05949c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.88,64.52a.12.12,0,1,1-.24-.06.13.13,0,0,1,.15-.09h0a.11.11,0,0,1,.08.14",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#05949c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.23,63.14a.13.13,0,0,1,.06.17.13.13,0,0,1-.17.06.12.12,0,0,1-.06-.16.14.14,0,0,1,.16-.07h0",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#05949c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.66,64.2a.13.13,0,1,1-.08-.16h0a.12.12,0,0,1,.08.16",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#05949c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.39,63.63h0a.13.13,0,0,1,.07.16.11.11,0,0,1-.16.07.12.12,0,0,1-.08-.16.13.13,0,0,1,.17-.07h0",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#05949c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.44,25.76",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(15.23 15.91)",
    style: {
      fontSize: "3.5px",
      fill: "#015866",
      fontFamily: "'BTekUp-Font', Arial, Helvetica"
    }
  }, "\r\n    We are a\r\n  "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(15.98 21)",
    style: {
      fontSize: "3.5px",
      fill: "#015866",
      fontFamily: "'BTekUp-Font', Arial, Helvetica"
    }
  }, "\r\n    agency\r\n  "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(7.06 25.51)",
    style: {
      fontSize: "1.9px",
      fill: "#323b3f",
      fontFamily: "'BTekUp-Font', Arial, Helvetica"
    }
  }, "\r\n    providing our clients with solutions that are\r\n  "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(7.55 27.73)",
    style: {
      fontSize: "1.9px",
      fill: "#323b3f",
      fontFamily: "'BTekUp-Font', Arial, Helvetica"
    }
  }, "\r\n    100% optimizable, scalable and measurable to\r\n  "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(3.79 29.94)",
    style: {
      fontSize: "1.9px",
      fill: "#323b3f",
      fontFamily: "'BTekUp-Font', Arial, Helvetica"
    }
  }, "\r\n    meet their technological needs. Our team experts\r\n  "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(4.89 32.16)",
    style: {
      fontSize: "1.8px",
      fill: "#323b3f",
      fontFamily: "'BTekUp-Font', Arial, Helvetica"
    }
  }, "\r\n    in innovation and digital transformation is dedicated\r\n  "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(4.19 34.37)",
    style: {
      fontSize: "1.9px",
      fill: "#323b3f",
      fontFamily: "'BTekUp-Font', Arial, Helvetica"
    }
  }, "\r\n    to ensuring that your brand achieves a distinctive\r\n  "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(5.59 36.59)",
    style: {
      fontSize: "1.9px",
      fill: "#323b3f",
      fontFamily: "'BTekUp-Font', Arial, Helvetica"
    }
  }, "\r\n    online presence through the selection of digital\r\n  "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(9.71 38.8)",
    style: {
      fontSize: "1.9px",
      fill: "#323b3f",
      fontFamily: "'BTekUp-Font', Arial, Helvetica"
    }
  }, "\r\n    tools and the precise application of\r\n  "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(10.88 41.02)",
    style: {
      fontSize: "1.9px",
      fill: "#323b3f",
      fontFamily: "'BTekUp-Font', Arial, Helvetica"
    }
  }, "\r\n    innovation strategies.\r\n  "), /*#__PURE__*/React.createElement("polygon", {
    points: "33.3 11.47 33.3 11.47 33.3 11.47 33.3 11.47",
    style: {
      fill: "#323b3f"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1, 0, 0, 1, 32.55, 13.14)",
    style: {
      fontSize: "1.5px",
      fill: "#323b3f",
      fontFamily: "'BTekUp-Font', Arial, Helvetica"
    }
  }, " WHERE YOU ", /*#__PURE__*/React.createElement("tspan", {
    style: {
      fill: "#f9f9f9"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: -0.8,
    y: 2.15
  }, "\r\n        STARTUP\r\n      ")))), /*#__PURE__*/React.createElement("path", {
    d: "M42.67,30.41l0,0s0,0,0,0,0,0,0,0a0,0,0,0,1,0,.08",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.74,30h0a0,0,0,0,1,0,0s0,0,0,0a0,0,0,0,1,0,0s0,0,0,0",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.79,29.64l0,0v0a0,0,0,0,1,0,0,0,0,0,0,1,0,.08",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8,29.25l0,0v0a0,0,0,0,1,0,0s0,0,0,0a0,0,0,0,1,0,0",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.79,28.86l0,0v0a0,0,0,0,1,0,0s0,0,0,0,0,0,0,.05",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.76,28.47l0,0h0s0-.05,0-.05,0,0,0,0,0,0,0,0",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.69,28.08s0,0,0,0v0a0,0,0,0,1,0,0s0,0,0,0,0,0,0,0",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6,27.71l-.05,0h0s0,0,0-.05,0,0,.05,0,0,0,0,.05",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2,25.33h0s0,0,0-.05,0,0,.06,0,0,0,0,0a0,0,0,0,1-.06,0",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.48,27.33a0,0,0,0,1,0,0h0s0,0,0,0a0,0,0,0,1,0,0,0,0,0,0,1,0,0",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.46,25.62h0s0,0,0-.05a0,0,0,0,1,.06,0,0,0,0,0,1,0,.05s-.05,0-.06,0h0",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.34,27a0,0,0,0,1-.05,0h0s0,0,0-.05a0,0,0,1,1,0,.07",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7,25.94h0a0,0,0,0,1,0-.05s0,0,.06,0a0,0,0,0,1,0,.06.06.06,0,0,1-.06,0",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.17,26.62a0,0,0,0,1-.06,0h0a0,0,0,0,1,0-.05.06.06,0,0,1,.06,0,0,0,0,0,1,0,.06",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.92,26.26h0s0,0,0-.05,0,0,.06,0a0,0,0,0,1,0,.06,0,0,0,0,1-.06,0h0",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.67,30.41l0,0s0,0,0,0,0,0,0,0a0,0,0,0,1,0,.08",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.74,30h0a0,0,0,0,1,0,0s0,0,0,0a0,0,0,0,1,0,0s0,0,0,0",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.79,29.64l0,0v0a0,0,0,0,1,0,0,0,0,0,0,1,0,.08",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8,29.25l0,0v0a0,0,0,0,1,0,0s0,0,0,0a0,0,0,0,1,0,0",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.79,28.86l0,0v0a0,0,0,0,1,0,0s0,0,0,0,0,0,0,.05",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.76,28.47l0,0h0s0-.05,0-.05,0,0,0,0,0,0,0,0",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.69,28.08s0,0,0,0v0a0,0,0,0,1,0,0s0,0,0,0,0,0,0,0",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6,27.71l-.05,0h0s0,0,0-.05,0,0,.05,0,0,0,0,.05",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2,25.33h0s0,0,0-.05,0,0,.06,0,0,0,0,0a0,0,0,0,1-.06,0",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.48,27.33a0,0,0,0,1,0,0h0s0,0,0,0a0,0,0,0,1,0,0,0,0,0,0,1,0,0",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.46,25.62h0s0,0,0-.05a0,0,0,0,1,.06,0,0,0,0,0,1,0,.05s-.05,0-.06,0h0",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.34,27a0,0,0,0,1-.05,0h0s0,0,0-.05a0,0,0,1,1,0,.07",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7,25.94h0a0,0,0,0,1,0-.05s0,0,.06,0a0,0,0,0,1,0,.06.06.06,0,0,1-.06,0",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.17,26.62a0,0,0,0,1-.06,0h0a0,0,0,0,1,0-.05.06.06,0,0,1,.06,0,0,0,0,0,1,0,.06",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.92,26.26h0s0,0,0-.05,0,0,.06,0a0,0,0,0,1,0,.06,0,0,0,0,1-.06,0h0",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.64,30.37s0,0,0,0l0,0a0,0,0,0,0,0-.08S42.64,30.34,42.64,30.37Z",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7,30a0,0,0,0,0,0,0h0s0,0,0,0a0,0,0,0,0,0,0S42.71,30,42.7,30Z",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.75,29.6v0l0,0a0,0,0,0,0,0-.08A0,0,0,0,0,42.75,29.6Z",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.76,29.21v0l0,0a0,0,0,0,0,0,0s0,0,0,0A0,0,0,0,0,42.76,29.21Z",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.75,28.82v0l0,0s0,0,0-.05,0,0,0,0A0,0,0,0,0,42.75,28.82Z",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.71,28.45l0,0s0,0,0,0,0,0,0,0,0,0,0,.05Z",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.69,28.08s0,0,0,0a0,0,0,0,0,0,0s0,0,0,0v0S42.67,28.09,42.69,28.08Z",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.55,27.68h0l.05,0s0,0,0-.05,0,0-.05,0S42.54,27.66,42.55,27.68Z",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.26,25.33s0,0,0,0,0,0-.06,0,0,0,0,.05h0A0,0,0,0,0,41.26,25.33Z",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.43,27.31h0a0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0S42.42,27.29,42.43,27.31Z",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.52,25.63a0,0,0,0,0,0-.05,0,0,0,0,0-.06,0s0,0,0,.05h0S41.5,25.64,41.52,25.63Z",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.28,27h0a0,0,0,1,0,0-.05S42.27,26.93,42.28,27Z",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.76,26a0,0,0,0,0,0-.06s0,0-.06,0a0,0,0,0,0,0,.05h0A.06.06,0,0,0,41.76,26Z",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.17,26.62a0,0,0,0,0,0-.06.06.06,0,0,0-.06,0,0,0,0,0,0,0,.05h0A0,0,0,0,0,42.17,26.62Z",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,26.27s0,0,0-.05,0,0-.06,0,0,0,0,.05h0A0,0,0,0,0,42,26.27Z",
    transform: "translate(-2.16 -14.84)",
    style: {
      fill: "#d6eef8"
    }
  }), /*#__PURE__*/React.createElement("text", {
    id: "CON1",
    opacity: 1,
    transform: "translate(11.37 18.68)",
    style: {
      fontSize: "3.5px",
      fill: "#1bbfd1",
      fontFamily: "'BTekUp-Font', Arial, Helvetica"
    }
  }, "\r\n    TECHNOLOGY\r\n  "), /*#__PURE__*/React.createElement("text", {
    id: "CON2",
    opacity: 0,
    transform: "translate(8.61 18.68)",
    style: {
      fontSize: "3.5px",
      fill: "#1bbfd1",
      fontFamily: "'BTekUp-Font', Arial, Helvetica"
    }
  }, "\r\n    COMMUNICATION\r\n  "), /*#__PURE__*/React.createElement("text", {
    id: "CON3",
    opacity: 0,
    transform: "translate(11.69 18.68)",
    style: {
      fontSize: "3.5px",
      fill: "#1bbfd1",
      fontFamily: "'BTekUp-Font', Arial, Helvetica"
    }
  }, "\r\n    MULTIMEDIA\r\n  "), _animate || (_animate = /*#__PURE__*/React.createElement("animate", {
    id: "animation1",
    xlinkHref: "#CON1",
    attributeName: "opacity",
    from: 1,
    to: 0,
    dur: "1s",
    fill: "freeze",
    begin: "0s;animation6.end"
  })), _animate2 || (_animate2 = /*#__PURE__*/React.createElement("animate", {
    id: "animation2",
    xlinkHref: "#CON2",
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "1s",
    fill: "freeze",
    begin: "animation1.end"
  })), _animate3 || (_animate3 = /*#__PURE__*/React.createElement("animate", {
    id: "animation3",
    xlinkHref: "#CON2",
    attributeName: "opacity",
    from: 1,
    to: 0,
    dur: "1s",
    fill: "freeze",
    begin: "animation2.end"
  })), _animate4 || (_animate4 = /*#__PURE__*/React.createElement("animate", {
    id: "animation4",
    xlinkHref: "#CON3",
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "1s",
    fill: "freeze",
    begin: "animation3.end"
  })), _animate5 || (_animate5 = /*#__PURE__*/React.createElement("animate", {
    id: "animation5",
    xlinkHref: "#CON3",
    attributeName: "opacity",
    from: 1,
    to: 0,
    dur: "1s",
    fill: "freeze",
    begin: "animation4.end"
  })), _animate6 || (_animate6 = /*#__PURE__*/React.createElement("animate", {
    id: "animation6",
    xlinkHref: "#CON1",
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "1s",
    fill: "freeze",
    begin: "animation5.end"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhoMobD);
export default __webpack_public_path__ + "static/media/whoMobD.d8be6ef3.svg";
export { ForwardRef as ReactComponent };